'use client';
import { Button, H1, H3, P, UniversalLink } from '@template/components';
import * as S from './styles.ts';
import ArchStandaloneSectionComponent from '@template/blocks/ArchStandaloneSection/component';

const NotFound = () => {
  return (
    <>
      <S.NotFoundWrapper>
        <S.NotFoundContainer>
          <H1>We're Sorry!</H1>
          <div>
            <H3
              style={{
                marginBottom: 12,
              }}
            >
              The page you are looking for seems to have gone AWOL!
            </H3>
            <P>
              Never fear! Our blood hounds are on the case and will track it
              down soon.
            </P>
          </div>
          <UniversalLink href='/public'>
            <Button size='lg'>Back to safety</Button>
          </UniversalLink>
        </S.NotFoundContainer>
      </S.NotFoundWrapper>
      <ArchStandaloneSectionComponent />
    </>
  );
};

export default NotFound;
